var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card fn-ui-nav-card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"nav-card__header"},[_vm._v(" "+_vm._s(_vm.headerText)+" ")]),_c('div',{staticClass:"nav-card__list"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }